import PageTitle from "../components/PageTitle";

function BlankPage() {
  return <PageTitle title="Blank page" />;
}

export default BlankPage;
